import { ACTIONS_ROUTE } from './constants';

export const getActionRoute = (action: string) => {
  return `/${ACTIONS_ROUTE}/${action}`;
};
